import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import './plugins/http-client/axios'
import UserBus from './utils/buses/UserBus'
import './sass/main.scss'
import '@/utils/filters'
import PageContent from '@/components/PageContent.vue'

Vue.config.productionTip = false

Vue.component('page-content', PageContent)

UserBus.mount()

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
